export class EventValidation {

	isValidEvent(evt) {
		if (evt.type === 'click') {
			return true;
		}
		if (evt.type === 'keyup') {
			return (evt.keyCode == 13 || evt.keyCode == 32);
		}
		return false;
	}

}
